'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var withToggle = function withToggle(Component) {
  var toggle = function (_React$Component) {
    _inherits(toggle, _React$Component);

    function toggle(props) {
      _classCallCheck(this, toggle);

      var _this = _possibleConstructorReturn(this, (toggle.__proto__ || Object.getPrototypeOf(toggle)).call(this, props));

      _this.state = { toggled: props.toggled };
      _this.toggle = _this.toggle.bind(_this);
      _this.toggleOn = _this.toggleOn.bind(_this);
      _this.toggleOff = _this.toggleOff.bind(_this);
      return _this;
    }

    _createClass(toggle, [{
      key: 'toggle',
      value: function toggle() {
        this.setState({ toggled: !this.state.toggled });
      }
    }, {
      key: 'toggleOn',
      value: function toggleOn() {
        this.setState({ toggled: true });
      }
    }, {
      key: 'toggleOff',
      value: function toggleOff() {
        this.setState({ toggled: false });
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, {
          toggled: this.state.toggled,
          onToggle: this.toggle,
          onToggleOn: this.toggleOn,
          onToggleOff: this.toggleOff
        }));
      }
    }]);

    return toggle;
  }(_react2.default.Component);

  return toggle;
};

exports.default = withToggle;


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/with-toggle/index.js
// module id = 133
// module chunks = 0